<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'800'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>Request Headers</span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span v-if="apenasVisualizar">
                    Este é o request headers da requisição de numero {{requisicaoEditar.id}}:
                </span>
                <span v-else>
                    Altere o request headers da requisição de numero {{requisicaoEditar.id}}:
                </span>

                <br>

                <v-divider class="my-3"/>

                <campo-vazio-mensagem v-if="apenasVisualizar && !requestHeaders" :mensagem="'Não há conteúdo no request headers desta requisição!'"/>

                <span style="white-space: pre-wrap" v-if="apenasVisualizar">{{requestHeaders}}</span>

                <v-textarea v-if="!apenasVisualizar"
                            v-model="requestHeaders"
                            class="required-field"
                            :error-messages="errors.collect('Request Headers id ' + requisicaoEditar.id)"
                            v-validate="exibirModal?'required': ''"
                            :name="'Request Headers id ' + requisicaoEditar.id"
                            label="Request Headers"
                            placeholder="Digite os headers"
                            rows="7"/>

            </v-card-text>

            <v-card-actions>
                <v-layout v-if="apenasVisualizar" class="justify-center">
                    <az-call-to-action id="botaoFechar"
                                       @click="$emit('cancelar')"
                                       css-class="botao-desativado" class="ma-2 py-2"
                                       slot="actions">
                        Fechar
                    </az-call-to-action>
                </v-layout>
                <v-flex v-else>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoCancelar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoConfirmar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CampoVazioMensagem from './CampoVazioMensagem'
export default {
    name: 'ModalEditarRequestHeadersRequisicao',
    components: {CampoVazioMensagem},
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        },
        apenasVisualizar:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            requestHeaders: null
        }
    },
    computed: {
        requisicaoRequestHeaders() {
            return this.requisicaoEditar.requestHeaders
        }
    },
    mounted() {
        this.requestHeaders = this.requisicaoRequestHeaders
    },
    methods:{
        confirmar() {
            if(!this.requestHeaders || this.requestHeaders.trim().length === 0 ){
                throw new Error('Request Headers não informado!')
            }
            this.requisicaoEditar.requestHeaders = this.requestHeaders
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
